import { render, staticRenderFns } from "./payBigCourseLists.vue?vue&type=template&id=54c953a5&scoped=true"
import script from "./payBigCourseLists.vue?vue&type=script&lang=ts"
export * from "./payBigCourseLists.vue?vue&type=script&lang=ts"
import style0 from "./payBigCourseLists.vue?vue&type=style&index=0&id=54c953a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c953a5",
  null
  
)

export default component.exports